import { useId, useRef, type ReactNode } from 'react';

import { DialogShell } from './DialogShell';

interface ConfirmationDialogProps {
  readonly cancelLabel?: string | null;
  readonly confirmLabel: string;
  readonly confirmTone?: 'danger' | 'primary';
  readonly description: ReactNode;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
  readonly returnFocusTo?: HTMLElement | null | undefined;
  readonly role?: 'alertdialog' | 'dialog';
  readonly title: string;
}

export function ConfirmationDialog({
  cancelLabel = 'Cancel',
  confirmLabel,
  confirmTone = 'primary',
  description,
  onCancel,
  onConfirm,
  returnFocusTo,
  role = 'alertdialog',
  title,
}: ConfirmationDialogProps) {
  const cancelButtonRef = useRef<HTMLButtonElement | null>(null);
  const confirmButtonRef = useRef<HTMLButtonElement | null>(null);
  const titleId = useId();
  const descriptionId = useId();

  return (
    <DialogShell
      className="new-map-dialog"
      descriptionId={descriptionId}
      initialFocusRef={cancelLabel ? cancelButtonRef : confirmButtonRef}
      onClose={onCancel}
      returnFocusTo={returnFocusTo}
      role={role}
      titleId={titleId}
    >
      <h2 id={titleId}>{title}</h2>
      <div className="new-map-dialog-description" id={descriptionId}>
        {typeof description === 'string' ? <p>{description}</p> : description}
      </div>
      <div className="new-map-dialog-actions">
        {cancelLabel ? (
          <button onClick={onCancel} ref={cancelButtonRef} type="button">
            {cancelLabel}
          </button>
        ) : null}
        <button
          className={confirmTone === 'danger' ? 'danger-action' : 'primary-action'}
          onClick={onConfirm}
          ref={confirmButtonRef}
          type="button"
        >
          {confirmLabel}
        </button>
      </div>
    </DialogShell>
  );
}
